import { Select } from "antd";
import { ComponentPropsWithoutRef } from "react";

interface SearchSelectProps<T> extends ComponentPropsWithoutRef<typeof Select> {
  list: T[];
  mapFn: (item: T) => {key: React.Key, value: any, label: any};
}

export const SearchSelect = function <T>({
  list,
  mapFn,
  ...props
}: SearchSelectProps<T>) {
  return (
    <Select
      showSearch
      filterOption={(inputValue, option) => // search by label
        option?.props.label.toLowerCase().includes(inputValue.toLowerCase())
      }
      {...props}
    >
      {list.map((item) => {
        const {key, value, label} = mapFn(item);
        return (
          <Select.Option key={key} value={value} label={label}>
            <div
              title={label}
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis"
              }}
            >
              {label}
            </div>
          </Select.Option>
        );
      })}
    </Select>
  );
}